import type { Transaction } from '@api/hooks/types/getTransactions';
import { TFunction } from 'i18next';

import { CardConfig } from '../types';

export const getPayerDetailsCard = (
	operation: Transaction,
	t: TFunction,
): CardConfig => ({
	title: t('payerDetails.title'),
	groups: [
		{
			fields: [
				{
					title: t('payerDetails.payerIdType'),
					content: operation?.primary_payer?.id?.type
						? t(
								`additionalDetails.IDOptions.${operation?.primary_payer?.id?.type?.toLocaleLowerCase()}`,
							)
						: null,
				},
				{
					title: t('payerDetails.payerId'),
					content: operation?.primary_payer?.id?.value,
				},
			],
		},
	],
});
